const saveResults = {
  saveResultsButton: 'Save results',
};

export default saveResults;
